import { businessIntelligenceTenantService } from '@/services/business-intelligence-tenant.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  async createBid({ commit }, bid) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .createBid(bid)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async updateBid({ commit }, { id, bid }) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .updateBid(id, bid)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async deleteBid({ commit }, id) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .deleteBid(id)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async getAllBidsByTenderIds({ commit }, ids) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .getAllBidsByTenderIds(ids)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async createAward({ commit }, award) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .createAward(award)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async updateAward({ commit }, { id, award }) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .updateAward(id, award)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async deleteAward({ commit }, id) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .deleteAward(id)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async getAllAwardsByTenderIds({ commit }, ids) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .getAllAwardsByTenderIds(ids)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async createPotentialBidder({ commit }, potentialBidder) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .createPotentialBidder(potentialBidder)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async updatePotentialBidder({ commit }, { id, potentialBidder }) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .updatePotentialBidder(id, potentialBidder)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async deletePotentialBidder({ commit }, id) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .deletePotentialBidder(id)
      .then(() => {
        commit('SUCCESS');
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
  async getAllPotentialBiddersByTenderIds({ commit }, ids) {
    commit('LOADING');
    return businessIntelligenceTenantService
      .getAllPotentialBiddersByTenderIds(ids)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((err) => {
        commit('ERROR', err);
        throw err;
      });
  },
};

const mutations = {
  LOADING(state) {
    state.status = {
      ...state.status,
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const biTenant = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
